import { useQuery } from "@apollo/client"
import { GetIntegrationSourcesDocument } from "@hydrologiq/gql-experience/graphql"
import { usePrimaryClientIfAvailable } from "../../providers/DualGraphQLProvider"

export const useIntegrationSources = () => {
  const client = usePrimaryClientIfAvailable()
  const { data, loading, error, refetch } = useQuery(GetIntegrationSourcesDocument, {
    client,
    // network-only: the hub keeps one Apollo client across organisation switches, so a cached
    // result could briefly show the previous organisation's Data Connectors
    fetchPolicy: "network-only",
  })

  return {
    sources: data?.getIntegrationSources ?? [],
    loading,
    error,
    refetch,
  }
}
